<template>
    <div class="wrapper" :class="{done : data.done}" ref="task">
        <h5 class="task-title">
            {{data.name}}
        </h5>
        <p>
            {{data.text}}
        </p>
        <div class="buttons-wrapper">
            <a @click="deleteTask(data.id)" class="waves-effect waves-light btn btn-delete"><i class="material-icons">delete_forever</i></a>
            <a @click="showModal" class="waves-effect waves-light btn btn-edit"><i class="material-icons">edit</i></a>
            <a @click="toggleDone(data.id)" class="waves-effect waves-light btn btn-complete"><i class="material-icons">done</i></a>
        </div>
        <modal v-if="modalDisplay" @close="closeModal">
            <h5>Edit task</h5>
            <input @keyup.enter="editTask" type="text" v-model="insertedTitle" placeholder="Add title" ref="input">
            <textarea id="textarea1" class="materialize-textarea" v-model="insertedText" placeholder="Add new description" ref="textarea"></textarea>
            <div class="button-wrapper">
                <a @click="closeModal" class="waves-effect waves-light btn btn-delete"><i class="material-icons">cancel</i></a>
                <a @click="editTask" :disabled="isDisable" class="waves-effect waves-light btn btn-complete"><i class="material-icons">done</i></a>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from './modal'
import M from 'materialize-css/dist/js/materialize.min.js'

export default {
  data () {
    return {
      modalDisplay: false,
      insertedTitle: this.data.name,
      insertedText: this.data.text
    }
  },
  props: ['data'],
  components: {
    modal
  },
  computed: {
    isDisable () {
      return this.insertedTitle === ''
    }
  },
  methods: {
    deleteTask (id) {
      this.$emit('animationleft')
      this.$nextTick(()=>this.$store.dispatch('deleteTaskById', id))
    },
    toggleDone (id) {
      this.$emit('animationright')
      this.$nextTick(()=>this.$store.dispatch('toggleDone', id))
    },
    showModal () {
      this.modalDisplay = true
      setTimeout(() => {
        M.textareaAutoResize(this.$refs.textarea)
        this.$refs.input.focus()
      }, 700) // after animation
    },
    closeModal () {
      this.modalDisplay = false
      this.clearFields()
    },
    clearFields () {
      this.insertedTitle = this.data.name
      this.insertedText = this.data.text
    },
    editTask () {
      this.$store.dispatch('editTask', {
        name: this.insertedTitle,
        text: this.insertedText,
        id: this.data.id
      })
      this.closeModal()
    }

  }
}
</script>

<style lang="scss" scoped>
    .wrapper {
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
        padding: 14px 20px;
        margin-bottom: 20px;
        transition: opacity .5s, background-color .5s, transform .7s;
        background-color: #ffffff82;
        p {
            white-space: pre-line;
        }
        &:hover{
          background-color: #fbe9e794;
        }
    }

    .slide{
      transform: translateX(-700px);
      opacity: 0;
    }

    .task-title {
        margin: 0;
    }

    .buttons-wrapper {
        border-top: 1px solid rgba(160, 160, 160, 0.2);
        padding-top: 14px;
        display: flex;
        justify-content: flex-end;
    }

    .done {
        opacity: .4;
    }

    .button-wrapper {
        display: flex;
        justify-content: flex-end;
    }
</style>



// WEBPACK FOOTER //
// src/components/task.vue